import script from "./LeaderboardTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderboardTable.vue?vue&type=script&setup=true&lang=js"

import "./LeaderboardTable.vue?vue&type=style&index=0&id=19ad319a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ad319a"]])

export default __exports__